var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingW(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6116_241791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 9V9.4V28.6V29H10.9282H27.1186H27.5234V28.6V9.4V9H27.1186H10.9282H10.5234ZM11.333 9.8H26.7139V28.2H11.333V9.8Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.2004V13.4004H23.8803V14.2004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 19.8004V19.0004H19.8327V19.8004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 19.8004V19.0004H23.8803V19.8004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 22.2004V21.4004H19.8327V22.2004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 22.2004V21.4004H23.8803V22.2004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 24.6004V23.8004H19.8327V24.6004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 24.6004V23.8004H23.8803V24.6004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.2004V13.4004H23.8803V14.2004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 19.8004V19.0004H19.8327V19.8004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 19.8004V19.0004H23.8803V19.8004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 22.2004V21.4004H19.8327V22.2004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 22.2004V21.4004H23.8803V22.2004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 24.6004V23.8004H19.8327V24.6004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 24.6004V23.8004H23.8803V24.6004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6116_241791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(10.5234 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingW);
export default __webpack_public_path__ + "static/media/billing-w.3f5068fe64b3c04545fd0484d09bdcfb.svg";
export { ForwardRef as ReactComponent };